// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/**
 * AngularJS fixed header scrollable table directive. - NOTE edited to our needs.
 * original @author Jason Watmore <jason@pointblankdevelopment.com.au> (http://jasonwatmore.com)
 * 
 * The attribute fixedHeaderScroll can have value of collection that will be shown in table or can be undefined. 
 * Attribute tbMaxRows is required to define how many rows we want in the scrollable table body.
 * To be used only on table tag.
 * @author teodora.krotkova
 */

import { app } from '../../../../app';

app.directive('fixedHeaderScroll',   ['$timeout', function ($timeout) {

        return {
            restrict: 'A',
            scope: {
                fixedHeaderScroll: '='
            },
            link: function ($scope, $elem, $attrs, $ctrl) {

                var elem = $elem[0];
               $scope.$watchCollection('fixedHeaderScroll', // $attrs.$observe('tbRowsNumber',
                function() {

                   //console.log($scope.fixedHeaderScroll);
                    

                    // wrap in $timeout to give table a chance to finish rendering
                    $timeout(function() {
                        
                        var tbody = elem.querySelector('tbody');
                        var rowsNumber =0; //tbRowsNumber;
                        if ($scope.fixedHeaderScroll == undefined) {
                            //if it wasn't set expected table length then we use the tbody rows number
                            rowsNumber = tbody.children.length;

                        } else {
                            rowsNumber=$scope.fixedHeaderScroll.length;
                        }
                     // reset display styles so column widths are correct when measured below
                        angular.element(elem.querySelectorAll('thead, tbody, tfoot')).css('display', '');
                        if (rowsNumber > $attrs.tbMaxRows) {
                            
                            var rowHeight = tbody.children[0].offsetHeight;
                            var bodyHeight = rowHeight * $attrs.tbMaxRows;
                         
                            // set widths of columns
                            angular.forEach(elem.querySelectorAll('tr:first-child th'), function(thElem, i) {

                                var tdElems = elem.querySelector('tbody tr:first-child td:nth-child(' + (i + 1) + ')');
                                var tfElems = elem.querySelector('tfoot tr:first-child td:nth-child(' + (i + 1) + ')');


                                var columnWidth = tdElems ? tdElems.offsetWidth : thElem.offsetWidth;
                                if (tdElems) {
                                    tdElems.style.width = columnWidth + 'px';
                                }
                                if (thElem) {
                                    thElem.style.width = columnWidth + 'px';
                                }
                                if (tfElems) {
                                    tfElems.style.width = columnWidth + 'px';
                                }
                            });

                            // set css styles on thead and tbody
                            angular.element(elem.querySelectorAll('thead, tfoot')).css('display', 'block');

                            angular.element(elem.querySelectorAll('tbody')).css({
                                'display' : 'block',
                                'height' : bodyHeight + 'px' || 'inherit',
                                'overflow' : 'auto'
                            });



                            // reduce width of last column by width of scrollbar
                          
                            var scrollBarWidth = tbody.offsetWidth - tbody.clientWidth;
                            if (scrollBarWidth > 0) {
                                // for some reason trimming the width by 2px lines everything up better
                                scrollBarWidth -= 2;
                                var lastColumn = elem.querySelector('tbody tr:first-child td:last-child');
                                lastColumn.style.width = (lastColumn.offsetWidth - scrollBarWidth) + 'px';
                            }
                        }
                    });


                });
            }
        };
   
}
]);


// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/fixed-header-scroll.directive.js